import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { formatBytes } from "helpers/FormatHelpers";
import { makeStyles } from "helpers/StyleHelper";
import { FormattedMessage as T } from "react-intl";
import DefaultMedia from "./DefaultMedia";

const useStyles = makeStyles((theme: Theme) => ({
  fileDetails: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    border: "1px dashed gray",
  },
  detailsWrapper: {
    marginLeft: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  },
  preview: {
    width: "350px",
  },
  image: {
    width: "100%",
  },
  closeIcon: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 10,
  },
}));

type MediaLibraryItemPreviewProps = {
  fileName: string;
  fileSize: number;
  contentType: string;
  dimensions?: string;
  imageSrc?: string;
  altText?: string;
  uploadedOn?: Date;
  uploadedBy?: string;
  onLoad?: (e: any) => void;
  onClose?: () => void;
};

const MediaLibraryItemPreview = ({
  fileName,
  fileSize,
  contentType,
  dimensions,
  imageSrc,
  altText,
  uploadedOn,
  uploadedBy,
  onLoad,
  onClose,
}: MediaLibraryItemPreviewProps) => {
  const styles = useStyles(useTheme());

  const isImage = (type: string) => {
    return type.startsWith("image/");
  };

  return (
    <Box sx={styles.fileDetails} position="relative">
      <Box>
        {isImage(contentType) ? (
          <Box sx={styles.preview}>
            <Box
              component="img"
              sx={styles.image}
              src={imageSrc}
              alt={altText}
              onLoad={onLoad}
            />
          </Box>
        ) : (
          <DefaultMedia contentType={contentType} />
        )}
      </Box>
      <Box sx={styles.detailsWrapper}>
        <Typography>{fileName}</Typography>
        <Typography>{contentType}</Typography>
        <Typography>{altText}</Typography>
        <Typography>{formatBytes(fileSize)}</Typography>
        {dimensions && <Typography>{dimensions}</Typography>}
        {uploadedBy && (
          <Typography>
            <T id="uploadedBy" values={{ uploadedBy: uploadedBy }} />
          </Typography>
        )}
        {uploadedOn && (
          <Typography>
            <T
              id="uploadedOn"
              values={{ uploadedOn: format(uploadedOn, "MM/dd/yy HH:mm:ss") }}
            />
          </Typography>
        )}
      </Box>
      {onClose && (
        <IconButton sx={styles.closeIcon} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default MediaLibraryItemPreview;
